import React from 'react'
import { motion, useScroll } from 'framer-motion'

import profileImage from './images/profile.jpg'

import Lines from './parts/Lines';

export default function About({goToSlide}) {
   return (
     <>
     <div id="about" className="container about">
      <div className="row">
         <div className="col-md-8 bio">
          <div className="ui-general">
             <div className="ui-text">Introduction</div>
          </div>
          <h2>Hey, I'm Boris Polderman.</h2>
          <p>I am a web developer from the Netherlands and currently living in 's-Hertogenbosch. I love building websites and webapplications. Having had five years of experience, I am passionate with helping businesses build and improve their online presence.</p>
          <p>My love for web development started in 2014. This was the year that I had my first study (Interactive Design) where I learned how to build simple HTML websites. I was intrigued by the possibilities that you have building websites that I immediately decided to move to another study that specialised in web development. And I have never regretted my decision.</p>
          <div className="button-section">
            <a role="button" className="btn" onClick={() => goToSlide(2)}><i className="fa fa-suitcase" aria-hidden="true"></i> Experience</a>
            <a role="button" className="btn" onClick={() => goToSlide(3)}><i className="fa fa-laptop" aria-hidden="true"></i> Projects</a>
          </div>
          <div className="profile">
            <div className="ui-profile">
               <div className="ui-profiletext">Profile</div>
            </div>
            <img src={profileImage} className="profile-image" />
          </div>
        </div>
      </div>
    </div>
    <Lines></Lines>
    </>
  );
}
